<template>
  <wtFormRight>
    <!-- -TOOLBARS -->
    <template slot="toolbars">
      <Toolbars 
        :objProps="objItem"        
        :noDelete="noDelete"
        :noModify="noModify"
        :noInsert="noInsert"
        :noFilter="noFilter"
      />
    </template>

    <!-- VIEW TABLE -->
    <template slot="table" v-if="showGrid">
      <SupportTicketInternshipGrid />
    </template>
  </wtFormRight>
</template>
<script>
/* COMPONENTS - LAYOUT */
import wtFormRight from "@/components/forms/wtFormRight";
import Toolbars from "@/components/widgets/Toolbars";

/* COMPONENTS - PAGE */
import SupportTicketInternshipGrid from "./SupportTicketInternshipGrid";

export default {
  name: "SupportTicketInternship",
  /* COMPONENTS IN USE */
  components: { wtFormRight, Toolbars, SupportTicketInternshipGrid },
  /* COMPUTED VARIABLES */
  computed: {
    showGrid() {
      return this.$store.state.layout.showGrid;
    },
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
  },
  /* VARIABLES */
  data: function() {
    return {
      objItem: {},
      noDelete: true,
      noModify: true,
      noInsert: true,
      noFilter: true,
    };
  },
};
</script>